import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { NgModel } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

export interface IItemActivation {
    StartDate: Date;
    EndDate: Date;
    IsActivated: boolean;
}

enum FiActivationType {
    Continuous = 0,
    TimeLimited = 1,
}

@Component({
    selector: 'fi-item-activation',
    templateUrl: './item-activation.component.html',
    styleUrls: ['./item-activation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FiComponentsContainer, useExisting: ItemActivationComponent }],
    host: { class: 'fi-item-activation' },
    standalone: false,
})
export class ItemActivationComponent extends FiComponentsContainer implements OnInit {
    @Input() activationData: IItemActivation;
    @Input() disabled = false;
    @Output() activationDataChange = new EventEmitter<void>();
    @Input() datePickerLabelStartDate: string;
    @Input() datePickerLabelEndDate: string;
    @Input() datePickerAppearance: MatFormFieldAppearance;
    activationType: FiActivationType;

    FiActivationType = FiActivationType;

    private _activationEndDate: Date;
    get activationEndDate() {
        if (!this._activationEndDate && this.activationData.EndDate) {
            return (this._activationEndDate = new Date(this.activationData.EndDate.getTime() - (86400000 - 1000))); // subtract 23:59:59
        }
        return this._activationEndDate;
    }
    set activationEndDate(value) {
        if (value) {
            this._activationEndDate = value;
            this.activationData.EndDate = new Date(value.getTime() + (86400000 - 1000)); // add 23:59:59
        } else {
            this._activationEndDate = undefined;
            this.activationData.EndDate = undefined;
        }
    }

    ngOnInit() {
        if (this.activationData.StartDate && typeof this.activationData.StartDate === typeof '') {
            this.activationData.StartDate = new Date(this.activationData.StartDate);
        }
        if (this.activationData.EndDate && typeof this.activationData.EndDate === typeof '') {
            this.activationData.EndDate = new Date(this.activationData.EndDate);
        }
        this.activationType =
            this.activationData.EndDate != null ? FiActivationType.TimeLimited : FiActivationType.Continuous;

        if (!this.activationData.IsActivated) {
            this.activationData.StartDate = new Date();
            this.activationData.StartDate.setHours(0, 0, 0, 0);
        }
    }

    getMaxStartDate() {
        return this.isActivationTimeLimited() ? this.activationData.EndDate : null;
    }

    getMinEndDate() {
        return this.isActivationTimeLimited() ? this.activationData.StartDate : null;
    }

    isActivationTimeLimited() {
        return this.activationType === FiActivationType.TimeLimited;
    }

    onActivationDataChanged() {
        this.activationDataChange.emit();
    }

    onActivationTypeChanged() {
        if (!this.isActivationTimeLimited()) {
            this.activationData.EndDate = null;
        }

        this.activationDataChange.emit();
    }
}
